<div id="registration-confirm" class="registration-confirm">
  <div class="banner-success">
    <img class="logo-banner" src="../../../assets/images/logo/logo.svg" alt="">
    <h3>{{ 'success.s1a' | translate }}</h3>
    <p>{{ 'success.s16a' | translate }}<br> {{ 'success.s16b' | translate }}</p>
  </div>
</div>
<div id="registration-confirm-add-text" class="registration-confirm-bottom-test">
  {{ 'modals.registeradd' | translate }}
</div>
<app-carousel></app-carousel>
<app-how-it-works></app-how-it-works>
<app-what-winners-say></app-what-winners-say>
<app-little-about-us></app-little-about-us>
<app-total-wins></app-total-wins>
<app-footer></app-footer>
